var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "c-modal",
    {
      attrs: {
        active: _vm.displayModal,
        title: _vm.title,
        "disable-scroll": true,
        "class-name": "move-field-modal",
      },
      on: { close: _vm.close },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c("c-button", {
                attrs: { size: "large", label: "Отменить" },
                on: { click: _vm.close },
              }),
              _c("c-button", {
                attrs: {
                  label: "Перенести",
                  color: "primary",
                  size: "large",
                  disabled: _vm.pending,
                  pending: _vm.pending,
                },
                on: { click: _vm.submit },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "form",
        {
          staticClass: "move-form",
          on: {
            submit: function ($event) {
              $event.preventDefault()
              return _vm.submit.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "form-group move-form__tab" },
            [
              _c("c-input", {
                attrs: {
                  type: "select",
                  label: "Вкладка назначения",
                  searchable: true,
                  items: _vm.tabsList,
                },
                model: {
                  value: _vm.tab,
                  callback: function ($$v) {
                    _vm.tab = $$v
                  },
                  expression: "tab",
                },
              }),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }